import { IonHeader, IonTitle } from '@ionic/react';
import React, { createContext, useContext, useState, ReactNode } from 'react';

type HeaderConfig = {
  title?: string;
  children?: ReactNode;
};

const HeaderContext = createContext<{
  header: HeaderConfig,
  setHeader: (config: HeaderConfig) => void;
}>({
  header: {},
  setHeader: () => {},
});

export const useHeader = () => useContext(HeaderContext);

export const HeaderProvider = ({ children }: { children: ReactNode }) => {
  const [header, setHeaderState] = useState<HeaderConfig>({});

  const setHeader = (config: HeaderConfig) => {
    setHeaderState(config);
  };

  return (
    <HeaderContext.Provider value={{ header, setHeader }}>
      {/* <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>

          {header.title && <IonTitle>{header.title}</IonTitle>}

          {header.children}
        </IonToolbar>
      </IonHeader> */}
      {children}
    </HeaderContext.Provider>
  );
};
